/**
 * DeviceRemoveDialog — Confirmation dialog for removing a device from the resident.
 */

import DeviceAlarmWarning from '../../../../../components/v2/DeviceAlarmWarning.jsx';

const DeviceRemoveDialog = ({
  deviceName, residentName,
  onClose, onConfirm, saving,
  /* The device is in alarm: removing is allowed, with DeviceAlarmWarning. */
  alarming = false,
}) => {
  return (
    <div className="pp-dialog-backdrop" onClick={onClose}>
      <div className="pp-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="pp-dialog__header">
          <h2 className="pp-dialog__title">Remove Device</h2>
          <button className="dp-drawer__close" onClick={onClose}>&#x2715;</button>
        </div>
        <div className="pp-dialog__body">
          <p style={{ margin: 0, lineHeight: 1.6 }}>
            Are you sure you want to remove <strong>{deviceName}</strong> from <strong>{residentName}</strong>?
          </p>
          <p style={{ margin: 'var(--space-2) 0 0', color: 'var(--color-text-muted)', fontSize: 'var(--font-size-sm)' }}>
            The device will be unassigned and deactivated. You can reassign it later.
          </p>
          <DeviceAlarmWarning show={alarming} />
        </div>
        <div className="pp-dialog__footer">
          <button className="dp-btn dp-btn--cancel" onClick={onClose} disabled={saving}>
            Cancel
          </button>
          <button className="dp-btn dp-btn--danger" onClick={onConfirm} disabled={saving}>
            {saving ? 'Removing\u2026' : 'Remove Device'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeviceRemoveDialog;
